module.exports = __webpack_public_path__ + "img/About-Dashboard-image.c4133435.svg";